import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/index.css'
import wx from 'weixin-js-sdk';
Vue.config.productionTip = false;
Vue.prototype.$wx = wx;
import i18n from "../src/langue/i18n.js"
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(Antd);
Vue.use(preview);

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
